<script lang="ts">
	import type { TrafficInformationEvent } from '../traffic/types';
	import TrafficAd from '$lib/components/advertising/TrafficAd.svelte';
	import NoTraffic from '$lib/components/traffic/NoTraffic.svelte';
	import * as m from '$paraglide/messages';
	import { mapTrafficEventTypeToScheme } from '../traffic/constants';
	import TrafficCard from '../traffic/TrafficCard.svelte';

	export let events: TrafficInformationEvent[];
	export let withSeoTraffic: boolean;
	export let isLoading = false;

	// Put index at second position if there are more than 1 ad, otherwise put it last
	$: adIndex = events.length > 1 ? 1 : events.length - 1;

	function getEventScheme(event: TrafficInformationEvent) {
		const eventType = event.type as keyof typeof mapTrafficEventTypeToScheme;
		return mapTrafficEventTypeToScheme[eventType];
	}
</script>

<div class="bg-neutral-weakest">
	<div class="flex flex-col gap-4 p-2 items-center">
		<div class="border-neutral-soft border-0.5 border-solid"></div>
		{#if isLoading}
			<TrafficCard isLoading />
			<TrafficCard isLoading />
			<TrafficCard isLoading />
		{:else if events?.length}
			{#each events as event, index (event.type + JSON.stringify(event.coordinates))}
				<TrafficCard
					scheme={getEventScheme(event)}
					info={event.description ?? undefined}
				/>
				{#if index === adIndex}
					<TrafficAd />
				{/if}
			{/each}
		{:else}
			<NoTraffic
				text={withSeoTraffic
					? m.alerts_traffic_panel__no_events__label()
					: m.alerts_traffic_panel__select_location__label()}
				refresh={withSeoTraffic}
				on:retry
			/>
			<TrafficAd />
		{/if}
	</div>
</div>
